import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAFsjcoBAmjy9Zgcq4BTxtJkfbNbwFn1qk",
  authDomain: "korken-lottery.firebaseapp.com",
  projectId: "korken-lottery",
  storageBucket: "korken-lottery.firebasestorage.app",
  messagingSenderId: "309467719330",
  appId: "1:309467719330:web:873a7b1e614921d25299fb"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);